import { CustomConverter, DateTimeConverter, JsonObject, JsonProperty, Optional } from 'json-ts-mapper';
import { CategorieMessage } from './enum-types/categorie-message';

@JsonObject
export class Message {
  constructor (
    id?: number,
    domaine?: string,
    categorie?: CategorieMessage,
    targetId?:number,
    format?: string,
    texte?: string,
    datePublication?: Date,
    dateDebut?: Date,
    dateFin?: Date
  ) {
    this.id = id as any;
    this.domaine = domaine as any;
    this.categorie = categorie as any;
    this.targetId = targetId as any;
    this.format = format as any;
    this.texte = texte as any;
    this.datePublication = datePublication as any;
    this.dateDebut = dateDebut as any;
    this.dateFin = dateFin as any;
  }

  @JsonProperty(Number)
  id: number;

  @JsonProperty(String)
  domaine: string;

  @JsonProperty(String)
  categorie: CategorieMessage;

  @JsonProperty(Number)
  @Optional
  targetId: number;

  @JsonProperty(String)
  format: string;

  @JsonProperty(String)
  texte: string;

  @JsonProperty(String)
  @CustomConverter(DateTimeConverter)
  datePublication: Date;

  @JsonProperty(String)
  @CustomConverter(DateTimeConverter)
  dateDebut: Date;

  @JsonProperty(String)
  @CustomConverter(DateTimeConverter)
  @Optional
  dateFin?: Date;
}
